import { render } from "./DelegateFormPopup.vue?vue&type=template&id=631617a3&scoped=true&ts=true"
import script from "./DelegateFormPopup.vue?vue&type=script&lang=ts"
export * from "./DelegateFormPopup.vue?vue&type=script&lang=ts"

import "./DelegateFormPopup.vue?vue&type=style&index=0&id=631617a3&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-631617a3"]])

export default __exports__